"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  palette: {
    primary: {
      main: "#28a5d3"
    },
    secondary: {
      main: "#000000"
    }
  },
  spacing: 15,
  typography: {
    htmlFontSize: 11
  }
};
exports.default = _default;